export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';
export const SET_MESSAGE_ORDER_DETAILS = 'SET_MESSAGE_ORDER_DETAILS';
export const SET_TICKET_DETAILS = 'SET_TICKET_DETAILS';
export const SET_TICKET_USER = 'SET_TICKET_USER';
export const SET_SHOW = 'SET_SHOW';

export const CLEAR_DATA = 'CLEAR_DATA';
